import useOnlineStatus from '@rehooks/online-status';
import MultiField from 'Components/Forms/MultiField';
import { useEffect, useState } from 'react';
import api from 'Services/api';
import valueStore from 'Services/valueStore';

const PPEList = ({ ppe, push, remove, required = false, ...props }) => {
  const isOnline = useOnlineStatus();
  const [suggestions, setSuggestions] = useState([]);

  const sync = () => {
    const getPPE = async () => await api.fetchPPE();

    getPPE().then(async (ppeList) => {
      const values = ppeList.map((item) => item.description);
      setSuggestions(values);
      await valueStore.set(`ppe`, values);
    });
  };

  useEffect(() => {
    const loadPPE = async () => {
      if (isOnline) {
        sync();
      } else {
        const storedPPE = await valueStore.getArray(`ppe`);
        setSuggestions(storedPPE || []);
      }
    };

    loadPPE();
  }, [isOnline]);

  return (
    <MultiField
      name="ppe"
      values={ppe}
      push={push}
      remove={remove}
      label="What PPE is required?"
      placeholder="Add new PPE"
      required={required}
      suggestions={suggestions}
      isSortable={false}
      valueKey="description"
    />
  );
};

export default PPEList;
